<template lang="html">
	<div class="sub-main column">
    <div class="sub-nav documents row">
			<nav>
				<router-link :to="{ name: item.uri }" class="item" v-for="item in menu" v-bind:key="item.key">
					{{ item.name }}
				</router-link>
			</nav>
    </div>
		<force-complete-profile-banner v-if="isForceCompleteProfile"/>
		<no-estate-short v-else-if="!isEstate"/>
		<div class="sub-page documents column take-place">
			<router-view></router-view>
		</div>
  </div>
</template>

<script>
import NoEstateShort from '@/components/NoEstateShort'
import { mapGetters } from 'vuex'
import ForceCompleteProfileBanner from '@/components/ForceCompleteProfileBanner'

export default {
	name: 'Documents',
	components: {
		NoEstateShort,
		ForceCompleteProfileBanner
	},
	data () {
		return {
			menu: [
				{
					key: 0,
					name: 'Mes informations générales',
					uri: 'Profile'
				},
				{
					key: 1,
					name: 'Mes Documents',
					uri: 'MyDocuments'
				},
				{
					key: 2,
					name: 'Mon paysage patrimonial',
					uri: 'PatrimonialLandscape'
				},
				{
					key: 3,
					name: 'Mon abonnement',
					uri: 'MySubscriptions'
				}
			]
		}
	},
	computed: {
		...mapGetters({
			isEstate: 'isEstate',
			isForceCompleteProfile: 'isForceCompleteProfile'
		})
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/views/Documents/index.vue